import React from 'react';
import { TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import { GroupInfo } from 'types/policyService';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { getProductLinesFromArray } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { createStyles } from './styles';

interface InsightsRowProps {
  groupInfo: GroupInfo;
}
const InsightsTableRow = ({ groupInfo }: InsightsRowProps): JSX.Element => {
  const classes = createStyles();
  const { groupName, agencyName, aorName, submittedBy, effectiveDate, productLine, submittedDate } = groupInfo;

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableCell}>{groupName}</TableCell>
      <TableCell className={classes.tableCell}>{agencyName}</TableCell>
      <TableCell className={classes.tableCell}>{aorName}</TableCell>
      <TableCell className={classes.tableCell}>{normDateToShortAmericanDate(effectiveDate)}</TableCell>
      <TableCell className={classes.tableCell}>{getProductLinesFromArray(productLine)}</TableCell>
      <TableCell className={classes.tableCell}>{submittedBy}</TableCell>
      <TableCell className={classes.tableCell}>{normDateToShortAmericanDate(submittedDate)}</TableCell>
    </TableRow>
  );
};

export default InsightsTableRow;
